<!--  -->
<template>
  <div class='' v-wechat-title="$route.meta.title = pageTitle">

    <div class="crumbs" v-if="hasbreadcrumbs">
      <div class='content'>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :to="item.path">{{item.name}}
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="pageState === 200">{{thisDefPageTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <slot v-if="pageState == 200">

    </slot>
    <div class="state-contnt notfoud-container" v-if="pageState == 404">
      <div>
        <img src="http://www.17sucai.com/preview/5276/2018-05-30/404/images/page-404_39c5442.png"
          style="margin:40px auto" />
      </div>
      <div>
        <router-link to="/" class="notfound-btn">返回首页</router-link>
      </div>
    </div>
    <div class="state-contnt notfoud-container" v-if="pageState == 500">
      <div>
        <img src="http://www.17sucai.com/preview/5276/2018-05-30/404/images/page-404_39c5442.png"
          style="margin:40px auto" />
      </div>
      <div>
        <router-link to="/" class="notfound-btn">返回首页</router-link>
      </div>
    </div>
    <div class="state-contnt" v-if="pageState == 0">
      <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';

  export default {
    //import引入的组件需要注入到对象中才能使用
    props: {
      defPageTitle: {
        type: String,
        default: undefined
      },
      pageDataUrl: {
        type: String,
        default: undefined
      },
      params: {},
      breadcrumbs: {
        type: Array,
        default: function () {
          return [];
        }
      },
      hasbreadcrumbs: {
        type: Boolean,
        default: false
      }
    },
    components: {},
    data() {
      //这里存放数据
      return {
        pageState: 0,
        pageTitle: "",
        thisDefPageTitle: ""
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      pageState: {
        immediate: true, // 这句重要
        handler(val) {
          this.initTitle(val)
        }
      },
      defPageTitle: {
        immediate: true,
        handler(val) {
          this.thisDefPageTitle = (val === undefined ? '' : val);
          this.initTitle(this.pageState)
        }
      }
    },
    //方法集合
    methods: {
      initTitle(pageState) {
        switch (pageState) {
          case 0:
            this.pageTitle = "纽朗 - 加载中";
            break;
          case 404:
            this.pageTitle = "纽朗 - 找不到数据";
            break;
          case 500:
            this.pageTitle = "纽朗 - 错误";
            break;
          case 200:
            this.pageTitle = "纽朗" + (this.thisDefPageTitle === "" ? '' : ' - ' + this.thisDefPageTitle);
            break;
        }
      },
      load(params) {
        var that = this;
        if (that.pageDataUrl === undefined) {
          that.pageState = 500;
          //这里是500
        } else {
          if (params === undefined) {
            params = {};
          }
          this.$request.get({
            params: params,
            url: that.pageDataUrl,
            callback: {
              success: function (data) {
                that.pageState = 200;
                that.$emit("paddingData", data);
              },
              not_found: function () {
                that.pageState = 404;
              },
              err: function (err) {
                that.pageState = 500;
                console.log(err);
              }
            }
          });
        }
      },
      reload(params, title) {
        this.pageState = 0;
        if (title !== undefined) this.thisDefPageTitle = title;
        this.load(params);
      }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.load(this.params);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
  };
</script>
<style  scoped>
  .state-contnt {
    width: 100%;
    display: flex;
    width: 980px;
    min-width: 980px;
    margin: auto;
    text-align: left;
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .loading {
    width: 150px;
    height: 15px;
    margin: 150px auto;
  }

  .loading span {
    display: inline-block;
    width: 15px;
    height: 100%;
    margin-right: 5px;
    border-radius: 50%;
    background-color: #455a64;
    /* background: lightgreen; */
    -webkit-animation: load 1.04s ease infinite;
  }

  .loading span:last-child {
    margin-right: 0px;
  }

  @-webkit-keyframes load {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .loading span:nth-child(1) {
    -webkit-animation-delay: 0.13s;
  }

  .loading span:nth-child(2) {
    -webkit-animation-delay: 0.26s;
  }

  .loading span:nth-child(3) {
    -webkit-animation-delay: 0.39s;
  }

  .loading span:nth-child(4) {
    -webkit-animation-delay: 0.52s;
  }

  .loading span:nth-child(5) {
    -webkit-animation-delay: 0.65s;
  }

  .notfound-btn {
    display: inline-block;
    border: 1px solid #ebedef;
    background-color: #239bf0;
    color: #fff;
    font-size: 15px;
    border-radius: 5px;
    text-align: center;
    padding: 10px;
    line-height: 16px;
    white-space: nowrap;
  }

  .notfoud-container {
    display: flex;
    flex-flow: column;
    text-align: center;
  }
</style>